import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow, truncateId } from "./ActorContextRow";

export const MarketplaceModuleActorContextTypename =
  "MarketplaceModuleActorContext" as const;

export const MarketplaceModuleActorContextFragment = graphql(`
  fragment MarketplaceModuleActorContextFields on MarketplaceModuleActorContext {
    __typename
    appId
    marketplaceAppId
    installationId
    appName
  }
`);

interface Props {
  data: FragmentOf<typeof MarketplaceModuleActorContextFragment>;
}

export function MarketplaceModuleActorContext({ data }: Props) {
  const p = readFragment(MarketplaceModuleActorContextFragment, data);
  return (
    <ActorContextRow>
      module {p.appName} (install {truncateId(p.installationId)})
    </ActorContextRow>
  );
}
